(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("73N7L", function(module, exports) {
const $523eeb45b17b6920$var$alertsGroups = document.querySelectorAll(".g-alerts");
$523eeb45b17b6920$var$alertsGroups.forEach((group)=>{
    let timeout = 100;
    const alerts = group.querySelectorAll(".i-alert");
    alerts.forEach((alert)=>{
        setTimeout(()=>{
            alert.classList.add("--show");
        }, timeout);
        timeout += 100;
    });
});
const $523eeb45b17b6920$var$alerts = document.querySelectorAll(".i-alert");
$523eeb45b17b6920$var$alerts.forEach((alert)=>{
    const closeButtons = alert.querySelectorAll(".i-alert__close");
    closeButtons.forEach((closeButton)=>{
        closeButton.addEventListener("click", ()=>{
            alert.classList.remove("--show");
            setTimeout(()=>{
                alert.remove();
            }, 300);
        });
    });
});

});

})();
//# sourceMappingURL=alert-item.aebd7d43.js.map
